/**
 * O que muda na tela de preferências de aviso de um app para o outro (D3, passo 19): a API (adaptador) e o cache, a cara das categorias,
 * os textos, o cartão de push, a moldura, a disposição das linhas. `VARIANTE_INTERNA` é a tela de sempre; a do portal está em
 * `components/portal/variantePreferenciasDoPortal.ts`.
 */
import { ADAPTADOR_INTERNO } from "@/hooks/usePreferenciasDeAviso";
import type { AdaptadorDePreferencias } from "@/services/preferenciasDeAvisoService";
import { TEXTOS_DO_PUSH_INTERNO, type TextosDoPush } from "./CartaoPushDoAparelho.textos";
import { CATEGORIAS_DE_AVISO, type ApresentacaoDaCategoria } from "./categoriasDeAviso";
import type { DisposicaoDaLinha } from "./LinhaDeAviso.constants";

export interface VarianteDasPreferencias {
  adaptador: AdaptadorDePreferencias;
  categorias: Record<string, ApresentacaoDaCategoria>;
  /** O parágrafo que explica os níveis, no topo do cartão da lista. */
  textoDosNiveis: string;
  /** A frase de orientação do alerta de erro da lista. */
  orientacaoDoErro: string;
  push: { basePath?: string; textos: TextosDoPush };
  /** Classes do contêiner da tela. */
  classeDaRaiz: string;
  /** Moldura dos três cartões (som, push e lista); sem ela, a do `Card`. */
  classeDoCartao?: string;
  disposicao: DisposicaoDaLinha;
  /** Quantas linhas o esqueleto desenha (as categorias do servidor). */
  linhasDoEsqueleto: number;
  /** A página já tem o seu título (o portal). */
  semCabecalho: boolean;
}

/** Texto aprovado (desenho §5.2) — não muda sem passar pelo Augusto. */
export const TEXTO_DOS_NIVEIS_INTERNO =
  "Aviso + som: aparece na tela e toca. Aviso sem som: só aparece na tela. Só no sino: não aparece " +
  "na tela, fica no sino para ver depois. Não receber: não entra nem no sino. Nas conversas, " +
  '"Só no contador do chat" é o número no menu Mensagens.';

export const VARIANTE_INTERNA: VarianteDasPreferencias = {
  adaptador: ADAPTADOR_INTERNO,
  categorias: CATEGORIAS_DE_AVISO,
  textoDosNiveis: TEXTO_DOS_NIVEIS_INTERNO,
  orientacaoDoErro: "Tente de novo. Se continuar, avise a TI.",
  push: { textos: TEXTOS_DO_PUSH_INTERNO },
  classeDaRaiz: "mx-auto max-w-5xl space-y-6",
  disposicao: "lado",
  linhasDoEsqueleto: 12,
  semCabecalho: false,
};
